if (!customElements.get('shipping-message')) {
  class ShippinggMessage extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initSection.bind(this));
    }

    initSection() {
      const variantPicker = this.closest('.product-info')?.querySelector('variant-picker');
      this.variantInventory = this.getVariantInventory();
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', (event) => {
          this.variantInventory.forEach(variant => {
            if (event.detail.variant.id === variant.id) {
              this.dataset.availability = variant.available;
              this.dataset.inventoryPolicy = variant.inventory_policy;
              this.dataset.backorder = variant.backorder;
              this.dataset.quantity = variant.inventory_quantity;

              this.classList.remove('product--available', 'product--continue', 'product--backordered', 'product--sold-out', 'shipping-message--available', 'shipping-message--available-low-stock');

              if (variant.inventory_quantity > 0) {
                this.inStock(variant.inventory_quantity);
              } else if (variant.inventory_policy === 'continue' && variant.backorder) {
                this.backorderDetail();
              } else if (variant.inventory_policy === 'continue') {
                this.backorder();
              } else {
                this.outOfStock();
              }
            }
          });
        });
      }
    }

    inStock(quantity) {
      let displayQuantity = '';
      let messageClass = 'shipping-message--available';

      if (quantity > 50) {
        displayQuantity = '50+';
        messageClass = 'shipping-message--available';
      } else if (quantity >= 6 && quantity <= 49) {
        displayQuantity = `${quantity}`;
        messageClass = 'shipping-message--available-high-stock';
      } else if (quantity >= 1 && quantity <= 5) {
        displayQuantity = `${quantity}`;
        messageClass = 'shipping-message--available-low-stock';
      }

      const deliveryMessage = this.dataset.palletShipping === 'true' 
        ? 'Immediate Dispatch' 
        : 'Next day delivery available';

      this.innerHTML = `<p class="${messageClass} shipping-message"><span class="shipping-message--prefix">${displayQuantity} in stock -</span><span>${deliveryMessage}</span></p>`;
      
      this.classList.add('product--available', messageClass);
    }

    backorderDetail() {
      this.innerHTML = `
        <input
          form="${this.dataset.formid}"
          type="hidden"
          name="properties[Backordered]"
          id="backordered-cart-message"
          value="Available in ${this.dataset.backorder} business days"
        >
        <p class="shipping-message--continue shipping-message">
          <span class="shipping-message--continue__prefix">Back ordered -</span> available in ${this.dataset.backorder} business days
        </p>`;
      
      this.classList.add('product--continue');
    }

    backorder() {
      this.innerHTML = `<p class="shipping-message--backordered shipping-message">Back ordered</p>`;
      this.classList.add('product--backordered');
    }

    outOfStock() {
      this.innerHTML = `<p class="shipping-message--out-of-stock shipping-message">Out of stock</p>`;
      this.classList.add('product--sold-out');
    }

    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }
  }

  customElements.define('shipping-message', ShippinggMessage);
}
